import type { Achievement } from "../achievement.types";
import { freeMoves } from "../moveHistory";

export const rareFindAchievement: Achievement = {
  id: "rareFind",
  name: "Rare Find",
  icon: "diamond-stone",
  description: "Chose the rarest word offered all game, and won.",
  isProgressive: true,
  // The winning click on the target is left out: of the remaining steps
  // (backtracked ones included), the player picked the rarest word offered at
  // the step whose rarest offer was the rarest of the game.
  // Rule unchanged from v1's Putting on the Dog (spec 2026-10-20 §3.2).
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport) return false;

    let steps: { frequency: number; chosen: boolean }[];
    if (Array.isArray(gameReport.moveHistory)) {
      steps = freeMoves(gameReport, gameStatus)
        .filter((m) => typeof m.rarestOfferedFrequency === "number")
        .map((m) => ({
          frequency: m.rarestOfferedFrequency as number,
          chosen: m.choseRarestNeighbor === true,
        }));
    } else {
      // Older reports: per-step rarest offers, with the target's own entry dropped.
      steps = (gameReport.potentialRarestMoves ?? [])
        .filter((p) => p.word !== gameReport.targetWord)
        .map((p) => ({
          frequency: p.frequency,
          chosen: p.playerChoseThisRarestOption === true,
        }));
    }
    if (steps.length === 0) return false;
    const rarest = Math.min(...steps.map((s) => s.frequency));
    if (!Number.isFinite(rarest)) return false;
    return steps.some((s) => s.frequency === rarest && s.chosen);
  },
};
